import React, { useEffect, useState } from 'react';
import { Shell, Spinner } from '../components/Shell';
import { API_BASE_URL, apiFetch, setToken } from '../lib/api';
import { buildReport, downloadHtml, fullPayload } from '../lib/report';

export default function ReportsPage() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [needLogin, setNeedLogin] = useState(true);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState('');

  const load = async () => {
    setLoading(true);
    setErr('');
    const res = await apiFetch(`${API_BASE_URL}/customer/downloads`);
    if (res.status === 401) { setNeedLogin(true); setList([]); setLoading(false); return; }
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { setErr(data.error || 'Failed'); setLoading(false); return; }
    setNeedLogin(false);
    setList(data.downloads || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const login = async (e) => {
    e.preventDefault();
    const res = await apiFetch(`${API_BASE_URL}/customer/session/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, phone }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { setErr(data.error || 'Login failed'); return; }
    if (data.customerToken) setToken(data.customerToken);
    await load();
  };

  const open = async (txnid) => {
    setBusy(txnid);
    setErr('');
    try {
      const res = await apiFetch(`${API_BASE_URL}/customer/downloads/${encodeURIComponent(txnid)}/bootstrap`, { method: 'POST' });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Failed');
      const body = fullPayload(data.token, data.ctx, data.records);
      const fullRes = await fetch(`${API_BASE_URL}/search/full-by-keys`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!fullRes.ok) throw new Error('Could not load');
      const full = (await fullRes.json()).results || [];
      downloadHtml(buildReport(full, data.ctx), `Zameenmahiti_${data.ctx?.query || 'report'}.html`);
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy('');
    }
  };

  return (
    <Shell narrow>
      <h1 className="text-xl font-bold mb-1">My reports</h1>
      <p className="text-sm text-muted mb-6">Use the same email and phone from checkout.</p>

      {needLogin && (
        <form onSubmit={login} className="card space-y-3 mb-6">
          <input type="email" required placeholder="Email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input type="tel" required placeholder="Mobile" className="input" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <button type="submit" className="btn w-full">Sign in</button>
        </form>
      )}

      {err && <p className="text-red-500 text-sm mb-4">{err}</p>}
      {loading ? <Spinner /> : (
        <ul className="space-y-3">
          {list.length === 0 && !needLogin && <li className="text-muted text-sm text-center py-8">No reports yet.</li>}
          {list.map((item) => (
            <li key={item.txnid} className="card flex justify-between items-center gap-3">
              <div className="text-sm">
                <p className="font-medium">#{item.query}</p>
                <p className="text-muted text-xs">{item.district} · {item.taluka}</p>
              </div>
              <button type="button" onClick={() => open(item.txnid)} disabled={busy === item.txnid} className="btn text-xs px-3 py-2">
                {busy === item.txnid ? '…' : 'Get'}
              </button>
            </li>
          ))}
        </ul>
      )}
    </Shell>
  );
}
